
export const parseAnalysisStream = (raw) => {
  const result = { steps: [], finalAnalysis: null, cost: null };
  if (!raw || typeof raw !== "string") return result;

  raw.split(/\n\n+/).forEach((block) => {
    let eventType = null;
    let dataStr = "";
    block.split("\n").forEach((line) => {
      if (line.startsWith("event:")) eventType = line.slice(6).trim();
      else if (line.startsWith("data:")) dataStr += line.slice(5).trim();
    });
    if (!eventType || !dataStr) return;

    let payload;
    try {
      payload = JSON.parse(dataStr);
    } catch {
      payload = dataStr;
    }

    if (eventType === "step_analysis") result.steps.push(payload);
    else if (eventType === "final_analysis") result.finalAnalysis = payload;
    else if (eventType === "completed") result.cost = payload;
  });

  return result;
};